import React, { useState, useRef, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Career.css";
import { useNavigate } from "react-router-dom";

function Career() {
    let navigate = useNavigate();
    const [data, setData] = useState(false);
 
    const routeChangeToCareer = (job_id) => {
        
        navigate("/CareersInner/" + job_id, {
        });
    };

    useEffect(() => {
       var url_Job_id = window.location
       url_Job_id = url_Job_id.href.split("/")[4]
        postData('/api/Login/Career', {"job_id":url_Job_id })
            .then((data) => {
                if (data.data != null && data.data.length > 0) {
                    setData(data.data);
                   // console.log("data: ", data)
                }
                else { setData(null); }
            });
    }, []);

    async function postData(url = '', data = {}) {
        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header

        });
        //console.log(response, "careerdata");
        return response.json(); // parses JSON response into native JavaScript objects

    }
    return (


        <>
            <section className="career-js">
                <Container>
                {data && data.map(({ job_title, location, department,no_of_openings,qualification
                        ,experince,profile,responsiblities,job_id}) => (
                    <Row>
                        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                        
                            <div className="apply-sc">
                                <h2 className="pageinnerhead">{job_title} - {department}</h2>
                                <p>{location}</p>
                                <p><b>No of Openings: </b>{no_of_openings}</p>
                                <p><b>Qualification: </b> {qualification}</p>
                                <p><b>Experience: </b> {experince}</p>
                                <p><b>Profile: </b> {profile}</p>
                                <p><b>Responsiblities: </b>{responsiblities}</p>
                                
                                
                            </div>
                       
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                            <div className="apply-btn">
                            <a onClick={() => { routeChangeToCareer(job_id) }}>Apply For This Job</a>
                        </div>
                        </Col>
                    </Row>
                     ))}
                </Container>
            </section>

            
        </>
    );
}
export default Career;